var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "CircleArrowLeft",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-circle-arrow-left","viewBox":"0 0 250 250"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <path d="M0 125C0 56.081 56.081 0 125 0s125 56.081 125 125-56.081 125-125 125S0 193.919 0 125zm9.99 0c0 63.417 51.593 115.01 115.01 115.01S240.01 188.417 240.01 125 188.417 9.99 125 9.99 9.99 61.583 9.99 125z"/>
  <path d="M134.266 179.44l10.618-10.57-41.023-41.167 41.988-35.763-9.7-11.39-54.344 46.284 52.461 52.606z"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/circle-arrow-left.svg